

































import { Component, Vue, Prop } from 'vue-property-decorator';
import { cloneDeep } from 'lodash-es';
import { formatCouponDate, formatCouponText, formatNumber } from '@/utils/helpers';
import CouponList from '../CouponList/CouponList.vue';
import './style.scss';

@Component({
  components: {
    CouponList,
  },
  filters: {
    formatDate(val: any) {
      return formatCouponDate(val);
    },
    formatPrice(val: any) {
      let date: any = val;
      return formatNumber(date);
    }
  },
})
export default class CouponModal extends Vue {
  @Prop() loading!: boolean;
  @Prop() coupons!: Array<any>;
  @Prop() coupon!: any;
  @Prop({ default: false }) isLimit?: boolean;
  @Prop({ default: false }) withGroup?: boolean;
  @Prop({ default: false }) buttonDisabled?: boolean;
  @Prop({ default: null }) onSelectCouponHandle?: Function | null;
  @Prop() setCouponHandle!: Function;
  @Prop() hideCouponHandle!: Function;
  public show: boolean = true;
  public selectedCoupon: any = cloneDeep(this.coupon);
  public formatCouponText: Function = formatCouponText;

  selectCouponHandle(item) {
    this.selectedCoupon = item;
    if (this.onSelectCouponHandle) {
      this.onSelectCouponHandle(item);
    }
  }
}
